import { render, staticRenderFns } from "./DocsSection.vue?vue&type=template&id=1dfb1b38&"
import script from "./DocsSection.vue?vue&type=script&lang=js&"
export * from "./DocsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports